export interface BlueLineProps {
  orientation?: "horizontal" | "vertical";
  className?: string;
}

/** 2px blue line dividing major regions (lineup vs bench, neutral zone). Decorative. */
export function BlueLine({ orientation = "horizontal", className = "" }: BlueLineProps) {
  const shape = orientation === "vertical" ? "h-full w-[2px]" : "h-[2px] w-full";
  return <div aria-hidden="true" className={`shrink-0 bg-blue ${shape} ${className}`} />;
}
